import { clientEnv } from '@/shared/config/env';
import { getDeviceId } from '@/shared/device/device-id';
import { requestJson } from '@/shared/request/http-client';

const SENT_KEY = 'fc.inviteVisitSent';

export type InviteLinkType = 'AGENT' | 'PLAYER';

interface InviteVisitPayload {
  code: string;
  landingPath: string;
  linkType: InviteLinkType;
  siteId: string;
  visitorId: string;
}

/**
 * 同一 tab 会话只上报一次：刷新不重复计 PV，新开 tab 视为一次新落地。
 * 返回 true 表示本次应上报。
 */
export function markInviteVisitSent(linkType: InviteLinkType, code: string) {
  if (typeof sessionStorage === 'undefined') return false;
  const token = `${linkType}:${code}`;
  try {
    if (sessionStorage.getItem(SENT_KEY) === token) return false;
    sessionStorage.setItem(SENT_KEY, token);
    return true;
  } catch {
    return false;
  }
}

/** 落地上报，fire-and-forget；失败静默，不影响注册流程。 */
export function reportInviteVisit(linkType: InviteLinkType, code: string, landingPath: string) {
  const trimmed = code.trim();
  if (!trimmed || !markInviteVisitSent(linkType, trimmed)) return;
  const payload: InviteVisitPayload = {
    code: trimmed,
    landingPath: landingPath.split('?')[0] ?? '/',
    linkType,
    siteId: clientEnv.siteId,
    visitorId: getDeviceId(),
  };
  void requestJson<void, InviteVisitPayload>('/v1/app/invite/visit', {
    body: payload,
    method: 'POST',
  }).catch(() => undefined);
}
